import useSeasons from './useSeasons';

export default useSeasons;
